// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '../static/css/common.css'
import VueLazyload from 'vue-lazyload'
//Vue.prototype.WebHOST = 'https://z.lzgd.com.cn/inliuzhou/2018/test/LiuzhouTourism/#/'//WebHOST
Vue.prototype.WebHOST = window.WebHOST
if(window.location.href.indexOf("z.lzgd.com.cn") > - 1)
{
  Vue.prototype.HOST = 'https://z.lzgd.com.cn/LiuzhouTourism/Server'//ServerHost
}  else {
  Vue.prototype.HOST = 'http://localhost:55214/Server'
}
//音频组件 
/*
Vue.prototype.musicPlayerIsShow = true
Vue.prototype.musicPlayerTop = '-97px'
Vue.prototype.musicPlayerLeft = 'auto'
Vue.prototype.musicPlayerRight = '2px'
Vue.prototype.firstMusicPlay = true

Vue.prototype.controlMusic = function(){
  var audio = document.getElementById("audio");
  if(audio.paused){
    this.playMusic();          
  } else{
     this.stopMusic();         
  } 
}

Vue.prototype.playMusic = function(){
  var audio = document.getElementById("audio");
  if(audio.paused){
    try{
      audio.play();
      document.getElementById("musicPlayerBtn").setAttribute("class", "on");
    }catch(e){

    }
  }
}

Vue.prototype.stopMusic = function(){
  var audio = document.getElementById("audio");   
  audio.removeAttribute("autoplay"); //如果有自动播放autoplay属性，pause()方法不起作用，这个方式去除只是把autoplay变成FALSE
  setTimeout(function(){
     document.getElementById("audio").pause();
     document.getElementById("musicPlayerBtn").setAttribute("class", "off");
  },100)
}
*/

//窗口管理
Vue.prototype.AllDialog  = []


  //目前窗口最高层级
    Vue.prototype.getAllDialogTopLevel = function(){
    let topLive = 0
    for(let key in Vue.prototype.AllDialog){
      if( Vue.prototype.AllDialog[key].level > topLive && !Vue.prototype.AllDialog[key].isHide()){           
        topLive = Vue.prototype.AllDialog[key].level
      }
    }
    this.c("目前窗口最高",topLive)
    return topLive
  },

//小程序
Vue.prototype.MPWEIXIN  = false
if( window.location.href.toLowerCase().indexOf("lnglat") > -1){
  Vue.prototype.MPWEIXIN = true
}
Vue.prototype.getQueryVariable = function(variable){

       var query = window.location.href.substring(1);       
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return pair[1];}
       }
       var vars = query.split("?");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return pair[1];}
       }
       return(false);
}
//用户当前坐标，URL传入
Vue.prototype.LngLat = Vue.prototype.getQueryVariable("LngLat")

//调试信息
Vue.prototype.c = function(title,msg){
  if(window.location.href.indexOf("localhost") != -1){
    console.log(title,msg)
  }
}
Vue.prototype.twohistory = [
{title:'乡村闲游',shareurl:'',desc:"来自柳州市文化广电和旅游局",shareimg:""}
]
Vue.prototype.firsthistory = [
{title:'乡村闲游',shareurl:'',desc:"来自柳州市文化广电和旅游局",shareimg:""}
]
//历史记录
Vue.prototype.history = [
  {title:'乡村闲游',shareurl:'',desc:"来自柳州市文化广电和旅游局",shareimg:""}
]
//是存在历史记录
Vue.prototype.existsHistory = function(url){
  this.history.forEach(function (value) {
    if(value.shareurl.indexOf(url) > -1){
      return true;
    }
  });
}

//适应以下两种模式，来获取url参数值：
///User/vip_card_manager/useless/219/id/18
///User/vip_card_manager?useless=219&id=18
Vue.prototype.getQueryString = function(name){
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var reg_rewrite = new RegExp("(^|/)" + name + "/([^/]*)(/|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  var q = window.location.pathname.substr(1).match(reg_rewrite);
  if(r != null){
      return unescape(r[2]);
  }else if(q != null){
      return unescape(q[2]);
  }else{
      return null;
  }
}

//移除loading
Vue.prototype.removeLoader = function(){  
  let loader = document.getElementById("loader-wrapper");    
  setTimeout(function() {
    try {
      loader.parentNode.removeChild(loader);
    } catch (e) {
    }
  }, 2000);
  if(loader){
    return true;
  } else{
    return false;
  }
}
//设置页面信息
Vue.prototype.setDocument = function(title,url,desc,shareimg){
  /*
  if(window.location.href.indexOf('/#/') > -1){
    Vue.prototype.WebHOST = 'https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/#/'
    
  }else{
    Vue.prototype.WebHOST = 'https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/'
  }
  */
  if(!title || title==null || title ==''){
    title = document.title
  }
  if(shareimg == null || shareimg == ''){
    shareimg = "https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/img/share.jpg?v=2"
  }
 // if(desc == null || desc == ''){
 if(url.indexOf("newsid")>-1){
   try{
          let h = this.twohistory[this.twohistory.length-1]
    desc = '乡村闲游-'+h.title//"来自柳州市文化广电和旅游局";
    }catch(e){
      desc = '乡村闲游-'+title//"";
    }
 }else{
    desc = '乡村闲游-'+title//"来自柳州市文化广电和旅游局";
  }
  //}
  if(title=='乡村闲游'){
    desc = "来自柳州市文化广电和旅游局"
  }else{
    
  }
  document.title = title
 // window.location.hash = url
  
 //历史记录
 this.history.push({title:title,shareurl:url,desc:desc,shareimg:shareimg})          


 this.$router.push(url)
  
  
//设置安卓分享
try{  
  window.JSInterface.set_share_url(title,Vue.prototype.WebHOST+url, shareimg);
}catch(e){
  
}

//设置微信分享
console.log("title:"+title)
try{
  var ua = window.navigator.userAgent.toLowerCase()
  if(ua.match(/MicroMessenger/i) == 'micromessenger'){
  //alert(Vue.prototype.WebHOST+url)
  window.wxInit(title,Vue.prototype.WebHOST+url,desc,shareimg)
  }else{
    
  }
}catch(e){
 // alert(1)
}
}

//设置页面信息
Vue.prototype.setDocumentV2 = function(title,desc,shareimg){
  let url = window.location.href;  
  if(!title || title==null || title ==''){
    title = document.title
  }
  if(shareimg == null || shareimg == ''){
    shareimg = "https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/img/share.jpg?v=2"
  }
  if(url.indexOf("newsid")>-1){
    try{            
      desc = '乡村闲游-'+h.title//"来自柳州市文化广电和旅游局";
      }catch(e){
        desc = '乡村闲游-'+title//"";
      }
  }else{
      desc = '乡村闲游-'+title//"来自柳州市文化广电和旅游局";
    }
  
  if(title=='乡村闲游'){
    desc = "来自柳州市文化广电和旅游局"
  }
  document.title = title 
  
  //历史记录
  this.history.push({title:title,shareurl:url,desc:desc,shareimg:shareimg})          
  
  //设置安卓分享
  try{  
    window.JSInterface.set_share_url(title,url, shareimg);
  }catch(e){
    
  }

  //设置微信分享 
  try{
    var ua = window.navigator.userAgent.toLowerCase()
    if(ua.match(/MicroMessenger/i) == 'micromessenger'){     
      window.wxInit(title,url,desc,shareimg)
    }
  }catch(e){  
  }
  
}

 


 var iOS = ( navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false )
 Vue.prototype.iOS = iOS
 
Vue.config.productionTip = false


 
//图片懒加载
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'static/img/error.png',
  loading: 'static/img/loading.gif',
  attempt: 1
})

//加载更多
//register globally
import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)
 
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js